<template>
  <div>
    <center class="m-3">
      <h2>{{ room.name }}</h2>
    </center>
    <div
      class="cell"
      v-for="(cell, index) in room.cells"
      :key="cell.id"
      style="text-align: center; margin: 15px; background: #fff; border-radius: 20px 20px 20px 20px; border: 1px dotted"
    >
      <b-row>
        <b-col cols="4">
          <div class="ml-3 my-3 mr-0 p-3" no-body>
            <h5 class="mb-3">Участок с пожарной нагрузкой {{ index + 1 }}</h5>
            <b-form @change="cellUpdate(cell)">
              <b-row class="my-1">
                <b-col sm="6">
                  <label>Площадь:</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input type="number" v-model="cell.S"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="6">
                  <label>Высота:</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input type="number" v-model="cell.H"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="6">
                  <label>Минимальное расстояние до других участков с пожарной нагрузкой:</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input type="number" v-model="cell.Lmin"></b-form-input>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </b-col>
        <b-col class="mr-3 my-3 ml-0">
          <b-btn
            @click="cellRemove(cell.id, index)"
            variant="danger"
            style="position: absolute; top: 10px; right: 25px"
            class="px-2 py-1"
            ><i class="fa fa-trash m-0"></i
          ></b-btn>
          <b-table :items="cell.loads" :fields="fields" striped outlined>
            <template v-slot:cell(type)="data">
              {{ types[data.item.substance0.type] }}
            </template>
            <template v-slot:cell(substance)="data">
              {{ data.item.substance0.name }}
            </template>
            <template v-slot:cell(action)="data">
              <b-btn
                class="m-1 ml-0 p-2"
                size="sm"
                variant="primary"
                @click="
                  Object.assign(cur_cell, cell);
                  cur_load = data.item;
                "
                v-b-modal.cellLoadEdit
                v-b-tooltip.hover
                title="Изменить"
                ><i class="fa fa-cog fa-lg"></i
              ></b-btn>
              <b-btn
                class="m-1 p-2"
                size="sm"
                variant="danger"
                @click="loadRemove(cell.id, index, data.item.id, data.index)"
                v-b-tooltip.hover
                title="Удалить"
                ><i class="fa fa-trash fa-lg"></i
              ></b-btn>
            </template>
          </b-table>
          <b-btn
            variant="primary"
            class="m-0"
            @click="
              Object.assign(cur_cell, cell);
              cur_cell.index = index;
              cur_load = {};
            "
            v-b-modal.cellLoadEdit
            >Добавить пожарную нагрузку</b-btn
          >
        </b-col>
      </b-row>
    </div>
    <br />

    <center><b-btn variant="primary" @click="cellAdd()">Добавить участок с нагрузкой</b-btn></center>

    <b-modal id="cellLoadEdit" ref="cellLoadEdit" hide-footer title="Изменить нагрузку">
      <newLoad
        @hideWindow="$refs.cellLoadEdit.hide()"
        :project="project"
        :load.sync="cur_load"
        :cell="cur_cell"
        :room="room"
        :substances="substances"
      ></newLoad>
    </b-modal>
  </div>
</template>
<style>
fieldset {
  border: unset !important;
}
</style>
<script>
import newLoad from "./new_load";
export default {
  name: "load",
  data() {
    return {
      types: { 1: "Газовая нагрузка", 2: "Жидкая нагрузка", 3: "Пылевая нагрузка", 4: "Твердая нагрузка" },
      substances: [],
      cur_load: { id: null, substance: null },
      cur_cell: {},
      fields: [
        // A regular column
        { key: "type", label: "Тип" },
        { key: "substance", label: "Вещество" },
        { key: "mass", label: "Масса, кг" },
        { key: "action", label: "Действия" },
      ],
    };
  },
  props: {
    project: Object,
    room: Object,
  },
  components: {
    newLoad,
  },
  created() {
    this.loadSubstances();
  },
  methods: {
    cellAdd() {
      this.$http
        .post("category/cells/create?room_id=" + this.room.id)
        .then((response) => {
          if (!this.room.cells) {
            this.$set(this.room, "cells", []);
          }
          this.room.cells.push(response.data);
        })
        .catch((e) => {
          if (e.response.data) {
            this.$set(this.model, "validator", e.response.data);
            this.$refs.projectForm.validate();
          }
        });
    },
    cellUpdate(data) {
      this.$http
        .post("category/cells/update?cell_id=" + data.id, data)
        .then(() => {})
        .catch((e) => {
          if (e.response.data) {
            this.$set(this.model, "validator", e.response.data);
            this.$refs.projectForm.validate();
          }
        });
    },
    cellRemove(cell_id, index) {
      this.$http
        .post("category/cells/remove?cell_id=" + cell_id)
        .then(() => {
          this.room.cells.splice(index, 1);
        })
        .catch((e) => {
          if (e.response.data) {
            this.$set(this.model, "validator", e.response.data);
            this.$refs.projectForm.validate();
          }
        });
    },
    loadRemove(cell_id, index, load_id, load_index) {
      this.$http
        .post("category/cells/load-remove?cell_id=" + cell_id + "&load_id=" + load_id)
        .then(() => {
          this.room.cells[index].loads.splice(load_index, 1);
        })
        .catch((e) => {
          if (e.response.data) {
            this.$set(this.model, "validator", e.response.data);
            this.$refs.projectForm.validate();
          }
        });
    },

    loadSubstances() {
      this.$http.get("category/cells/substances").then((response) => {
        this.substances = response.data;
      });
    },
  },
};
</script>
